export default __webpack_public_path__ + "static/media/support-team-clayton.4281282e.png";